import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Skuska} from '../model/skuska';
import { HttpClient } from '@angular/common/http';
import {AppService} from '../app.service';
import {TranslateService} from '@ngx-translate/core';
import {Student} from '../model/Student';

@Component({
    selector: 'app-termin-zoznam-prihlasenych',
    templateUrl: './termin-zoznam-prihlasenych.component.html',
    styleUrls: ['./termin-zoznam-prihlasenych.component.css'],
    standalone: false
})
export class TerminZoznamPrihlasenychComponent implements OnInit {
  terminIn: Skuska;
  loading = true;
  studenti: Student[] = [];

  constructor(
    public dialogRef: MatDialogRef<TerminZoznamPrihlasenychComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {termin: Skuska},
    private http: HttpClient,
    private appService: AppService,
    private translation: TranslateService
  ) { }

  ngOnInit(): void {
    this.terminIn = this.data.termin;

    this.http.get<Student[]>(
      '/ais/rest/portal/student-predmety/termin-prihlaseni/' + this.data.termin.id
    )
      .subscribe(
        (data) => {
          this.studenti = data;
          this.loading = false;
        },
        (error) => {
          this.appService.openErrorDialog(error.error.message);
        },
        () => {}
      );
  }

}
